let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("6m5cK")).then(() => parcelRequire('4opAu'));